/**
 * Unpacks the first four entries of a plan's `referrals` array (each entry is
 * a JSON string describing a person who signed up, or a falsy placeholder).
 * `people[i]` is the `JSON.parse`d referral when the entry is truthy, `false`
 * otherwise, and `inviteCounter` is `index + 1` of the last truthy entry
 * (0 when none) — matching the historical unpacking done by the dashboard and
 * FlyShare rewards screens.
 */
export function parseReferrals(referrals: unknown[] | null | undefined): { people: any[]; inviteCounter: number } {
  const people: any[] = [false, false, false, false];
  let inviteCounter = 0;

  if (referrals) {
    for (let i = 0; i < 4; i++) {
      if (referrals[i]) {
        inviteCounter = i + 1;
        people[i] = JSON.parse(referrals[i] as string);
      }
    }
  }

  return { people, inviteCounter };
}
